import axios from 'axios'
import router from "../router"
import { Message, Loading } from 'element-ui';
// create an axios instance
const service = axios.create({
    baseURL: 'https://wxcollect.api.bytell.cn',
    timeout: 60000
})

axios.defaults.retry = 4
axios.defaults.retryDelay = 4000
axios.defaults.withCredentials = true
console.log('axios.defaults.withCredentials', axios.defaults.withCredentials)
let loading;

function startLoading() { //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        target: '.otable1',
        text: '加载中',
    })
}

function endLoading() { //使用Element loading-close 方法
    loading.close()
}
service.interceptors.request.use(config => {
    // startLoading();
    //   config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    return config
})

// axios 请求处理超时处理

service.interceptors.response.use(function(response) {
    
    return response
}, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err)
    }

    // Increase the retry count
    config.__retryCount += 1

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, config.retryDelay || 1)
    })

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
        return axios(config);
    })
})

export default service